export default "__VITE_ASSET__6ba3401f__"